/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts/preview_sql/:query_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohortsPreviewSqlQueryId } from "./constants";
import type { SegmentCohortsGetSqlPreviewResult } from "./types";

export const segmentCohortsPreviewSqlResults = reactQueryFetcherAdapter(
  engagementApiSegmentCohortsPreviewSqlQueryId,
  (signal: AbortSignal, queryId: string): Promise<SegmentCohortsGetSqlPreviewResult> => {
    return fetch(
      `/engagement/api/segment_cohorts/preview_sql/${queryId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
